<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="渠道名称" prop="content" >
        <a-input v-model="form.content" placeholder="请输入" disabled />
      </a-form-model-item>
      <a-form-model-item label="分配规则" prop="ruleType" >
        <a-select v-model="form.ruleType" placeholder="请选择">
          <a-select-option :value="1">指定人员</a-select-option>
          <a-select-option :value="2">系统默认分配规则</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="分配人员" prop="userIds" v-if="form.ruleType === 1" >
        <div :style="{ width: '900px' }">
          <a-tag v-for="(user,index) in userInfo" :key="index" @click.stop="closeTag(user.userId)">
            {{user.nickname + ' (' + user.mobile + ')'}}
          </a-tag>
        </div>
        <a-button type="primary" @click="addFormUser">
          添加
        </a-button>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
      <select-model-user-form ref="userFrom" @ok="selectModalUserFormOk"></select-model-user-form>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getRule, addRule, updateRule, queryUserByIds} from '@/api/user/rule'
import SelectModelUserForm from './SelectModelUserForm'
import Editor from '@/components/Editor'

export default {
  name: 'ThreeUpdateForm',
  props: {
  },
  components: {
    Editor,
    SelectModelUserForm
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: 3,

        content: null,

        dayNum: null,

        ruleType: 2,

        userIds: null,

        status: 1,

        qrCodeUrl: null,

        cateName: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      userInfo: [],
      queryParam: {
        userIds: null,
      },
      rules: {
        content: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    closeTag(userId) {
      this.form.userIds = this.form.userIds.replace(userId, '')
      this.userInfo = this.userInfo.filter(item => item.userId !== userId)
    },
    selectModalUserFormOk(userList) {
      this.form.userIds = userList.map(item => item.userId).join(',')
      this.userInfo = userList
    },
    addFormUser() {
      this.$refs['userFrom'].openByThreeClient(this.userInfo)
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 3,
        content: null,
        dayNum: null,
        ruleType: 2,
        userIds: null,
        status: 1,
        qrCodeUrl: null,
        cateName: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRule({"id":id}).then(response => {
        this.form = response.data
        this.queryParam.userIds = this.form.userIds
        queryUserByIds(this.queryParam).then(response => {
          this.userInfo = response.data
          this.form.userIds = this.userInfo.map(item => item.userId).join(',')
        })
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRule(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRule(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
